import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import EditSubmissionModal from '../components/EditSubmissionModal';
import { buildHeaders } from '../services/apiService';

/**
 * DirectSubmissionPage
 * Deep link route that opens a specific submission directly in the existing EditSubmissionModal.
 *
 * URL: /submission/:inspectionId
 */
const DirectSubmissionPage = ({ backendUrl, currentUser }) => {
  const { inspectionId } = useParams();
  const navigate = useNavigate();

  const [inspection, setInspection] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    const id = inspectionId;
    if (!id) return;
    if (!backendUrl) return;
    if (!currentUser || currentUser === 'Not logged in') return; // wait for auth/onboarding

    const run = async () => {
      try {
        setError('');
        setLoading(true);
        // Base64 encode email to bypass WAF
        const encodedEmail = btoa(currentUser);
        const url = `${backendUrl}/api/inspections/${encodeURIComponent(id)}/user-view?user_email=${encodedEmail}`;
        const res = await fetch(url, { headers: buildHeaders() });
        const data = await res.json();
        if (res.ok && data?.success && data.inspection) {
          setInspection(data.inspection);
        } else {
          setError(data?.detail || data?.error || 'Unable to load that submission.');
        }
      } catch (e) {
        setError(e.message || 'Unable to load that submission.');
      } finally {
        setLoading(false);
      }
    };

    run();
  }, [inspectionId, backendUrl, currentUser]);

  return (
    <div className="min-h-screen bg-[var(--pbfs-navy)]">
      {loading && (
        <div className="p-6 text-white/80 text-sm">
          Loading submission…
        </div>
      )}
      {error && (
        <div className="p-6 text-red-300 text-sm">
          {error}
        </div>
      )}

      <EditSubmissionModal
        isVisible={!!inspection}
        inspection={inspection}
        currentUser={currentUser}
        onClose={() => {
          // Prefer returning to the previous page (e.g., admin preview). If there's no history, fallback.
          try {
            if (window.history.length > 1) {
              navigate(-1);
              return;
            }
          } catch (e) {
            // ignore
          }
          navigate('/leaderboard');
        }}
        onSaved={(updated) => setInspection(updated)}
      />
    </div>
  );
};

export default DirectSubmissionPage;


